import axios from "axios";

export default axios.create({
	withCredentials: true,
	baseURL: process.env.MIX_APP_URL
});
